import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import GalleriaCanvas from '../components/GalleriaCanvas/GalleriaCanvas';

const Galleria = ({pagesLeft,pagesRight,photos}) => {
  return (
    <div>
        <Navbar pagesLeft={pagesLeft} pagesRight={pagesRight}></Navbar>
        <GalleriaCanvas photos={photos}></GalleriaCanvas>
    </div>
  )
}

export default Galleria